export const BASE_URL = process.env.REACT_APP_BASE_URL_API
//export const BASE_URL = "https://api.mktademicon.com.br/api/kavak"